/* eslint-disable import/named */
/* eslint-disable consistent-return */
import React, { useContext } from 'react';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import { GeneralContext } from '../../../../../core/app-context/GeneralContext';
import { ButtonsDropMenu } from '../../../../../core/route/menuRoutes.json';
import ButtonMenuHeader from '../ButtonMenuHeader';
import { ContainerPerfil, DropMenuPerfil } from './styles';
import UserAvatar from '../../../../../shared/components/UserAvatar';
import AuthService from '../../../../../core/auth/AuthService';

function Perfil() {
  const { menuOpen, setMenuOpen, user } = useContext(GeneralContext);

  const imageUrl = sessionStorage.getItem('cliqueretire-portal-pedidos-image'); //!

  const handleOpenMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <>
      <ContainerPerfil onClick={handleOpenMenu}>
        <UserAvatar imageUrl={imageUrl} />
        <label htmlFor="user-name">{user?.firstName}</label>
        <KeyboardArrowDownIcon className="arrow-icon" />
      </ContainerPerfil>
      <DropMenuPerfil
        className="animate__animated animate__fadeIn"
        open={menuOpen}
      >
        {ButtonsDropMenu.map((data) => {
          return (
            <ButtonMenuHeader
              key={data.id}
              id={data.id}
              icon={data.icon}
              label={data.label}
              path={data.path && data.path}
              onClick={data.id === 'logout' ? AuthService.doLogout : null}
            />
          );
        })}
      </DropMenuPerfil>
    </>
  );
}

export default Perfil;
